import {observable, action} from 'mobx';
import {DomainStore} from 'shared/store';
import {redirect} from 'shared/tools';
import {User} from 'main/stores/users';
import _ from 'lodash';
import {endpoints, types} from 'main/tools';

class PasswordResetState {
  store = new DomainStore();
  @observable user = new User();
  @observable errors = {};

  @action async submit() {
    const {errors} = await this.store.patch(
      endpoints.PASSWORD_RESETS.with(this.token),
      types.USER,
      this.user
    );

    if (_.isEmpty(errors)) {
      await redirect('/user_session/new?password_reset_successful=true')
    }

    this.errors = errors;
  }

  get token() {
    const pathParts = window.location.pathname.split('/');
    return pathParts[2];
  }
}

export default PasswordResetState;
